import { useMemo } from 'react';
import { useImportExportApi } from '../../../clients/quipli-service/import-export/import-export-api';
import { ImportExportAdapter } from '../../../components/import-export/types';
import { DateTime } from 'luxon';
import { toast } from '../../../util/toasts';
import { Typography } from '../../../components/typography/typography';

type CategoriesImportParams = Record<string, never>;
type CategoriesExportParams = Record<string, never>;

export const useCategoriesImportExportAdapter = (
  fetchCallback: () => void,
): ImportExportAdapter<CategoriesImportParams, CategoriesExportParams> => {
  const api = useImportExportApi();

  return useMemo(
    () => ({
      typeLabel: 'categories',
      fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',

      defaultExportFileName: () => `Categories_${DateTime.local().toFormat('D').replaceAll('/', '-')}`,

      export: () => api.exportCategories(),
      import: (file: File) => api.importCategories(file),

      onImportSuccess: () => {
        toast('File uploaded successfully. You will received an email when the import is complete.', 'success');
        fetchCallback();
      },
      onImportError: () => {
        toast('Error importing categories', 'error');
        fetchCallback();
      },
      onExportSuccess: () => {
        fetchCallback();
      },
      onExportError: () => {
        toast('Error exporting categories', 'error');
        fetchCallback();
      },

      renderSampleFile: () => (
        <div className="text-left px-4 mb-4">
          <Typography type="text-sm" className="text-grey-500">
            <div>Upload an Excel file (XLS or XLSX) in the exported format to update your category list.</div>
          </Typography>
        </div>
      ),
    }),
    [fetchCallback],
  );
};
